exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body-minimum[data-v-08fd90b2]{min-height:100px}", ""]);

// exports
